import { useTranslation } from "react-i18next";
import { supportedLngs } from "./config";
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import TranslateIcon from '@mui/icons-material/Translate';

export default function LocaleSwitcher() {
  const { i18n } = useTranslation();

  return (
    <FormControl fullWidth>
        <Select
          style={{ width: '100%'}}
          value={i18n.resolvedLanguage}
          onChange={(e) => i18n.changeLanguage(e.target.value)}
          startAdornment={
            <InputAdornment position="start" sx={{ mr: '12px', ml: '2px' }}>
              <TranslateIcon sx={{ color: 'var(--de-accent-warm)', fontSize: 20 }} />
            </InputAdornment>
          }
          // Drop the options list directly UNDER the field (flush, full-width)
          // instead of MUI's default overlay-the-selected-item placement.
          MenuProps={{
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            transformOrigin: { vertical: 'top', horizontal: 'left' },
            marginThreshold: 0,
            disableScrollLock: true,
          }}
        >
          {Object.entries(supportedLngs).map(([code, name]) => (
                <MenuItem value={code} key={code}>{name}</MenuItem>
          ))}
        </Select>
        </FormControl>
  );
}